import { memo } from "react";
import SettingsCard from "../common/settings-card";
import Faq from "./faq";

const FaqSettings = () => {
  return (
    <SettingsCard>
      <Faq />
    </SettingsCard>
  );
};

export default memo(FaqSettings);
